export interface ValidationErrorDetail {
  code: string;
  message: string;
  value?: any;
  constraints?: Record<string, any>;
}

export enum ApiErrorCode {
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  API_ERROR = 'API_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export interface ApiError {
  code: string;
  error: string;
  type?: string;

  message: string;
  statusCode: number;
  timestamp?: string;
  path?: string;
  method?: string;
  validationErrors?: Record<string, ValidationErrorDetail>;
  details?: {
    requestId?: string;
    errorId?: string;
    helpUrl?: string;
  };
  metadata?: {
    entity?: string;
    operation?: string;
    fields?: string[];
  };
}

export interface ApiResponse<T> {
  data?: T;
  error?: {
    error: ApiError;
  };
} 